import React, { useEffect, useState,useRef } from 'react'
import { connect } from 'react-redux'
import history from '../../../route/history'
import { uriConstants } from '../../../store/constants'
import Input from '../../../module/input'
import { useHistory } from 'react-router'
import { alertActions, authActions, govCertapplyActions, userinfoActions} from '../../../store/actions'
import { commons } from '../../../hook/common'
import moment from 'moment'

import { KAKAO_AUTH_URL, NAVER_AUTH_URL } from '../../oauth/OAuth'
import KTnetModal3 from '../../../module/ktnet/KTnetModal3'
import $ from 'jquery'
import * as common from '../../../assets/js/common.js'

import ico_eye from '../../../assets/images/sub/eye_1.png'
import ico_eye_slash from '../../../assets/images/sub/eye_slash_1.png'

import axios from 'axios'

const Login = (props) => {
  //console.log('userAgent', navigator.userAgent.toLowerCase())
  // 공인인증 툴킷open 여부
  const [isKTnetOpen, setIsKTnetOpen] = useState(false)
  const [pType, setPType] = useState('password')
  const [deviceId, setDeviceId] = useState('')
  const history = useHistory()

  let [state, setState] = useState({
    userName: '',
    password: '',
    isSaveId: false,
    submitted: false,
    data: null,
    bioFail: '',
    uuid: null,
    crtfctDetailList: [],
    selectedCrtfctInfo: '',
    crtfctPassword: '',
    editableColor: '',
    selected: false,
  })
  
  useEffect(() => {
    if (common.getDeviceType() === 'MobileApp') {
      let uuid = window.M.info.device('uuid')
      checkUuid(uuid)
      setDeviceId(window.M.info.device('uuid'))
    }
    console.log(props.location)
  }, [])
  const [signedData,setSignedData] = useState('')
  const didMount = useRef(false)
  const onlyNum = /[^0-9]/g
  const removeQ = /^\?/g
  useEffect(()=>{
    if (!didMount.current){
      didMount.current=true
      return
    }
    if(signedData !==''){
      let paramUrlCode = props.location?.search?.split("=")[0]
      let paramEcdwAdres=props.location?.search?.split("=")[1]
      if(paramUrlCode){
        paramUrlCode = paramUrlCode.replace(removeQ,'')
      }
      const params = {
        signedData: signedData,
        ecdwAdres: paramEcdwAdres,
        urlCode: paramUrlCode,
        deviceId:deviceId
      }
    // let paramsTest2 = {}
    // Object.assign(paramsTest2,{url:'Login.js 77'})
    // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest2,{headers:{},})
      // 지갑 화면 URL 요청
      props.getScreenURL(params)
    }
  },[signedData])
  useEffect(() => {    
    if (props.uuid != null) {
      console.log('uuid', props.uuid?.uuid)
      console.log('memberId', props.uuid?.memberId)
      if (props.uuid?.uuid === undefined) {
        window.M.data.removeStorage('memberId')
      }
    }
  }, [props.uuid])
  
  const checkUuid = (param) => {    
    props.checkUuid(param)
  }
  
  const [active, setActive] = useState(1)
  
  const simplLogin = props.simplLogin
  
  //간편번호 로그인
  function pinAuth() {    
    let memberId = window.M.data.storage('memberId')
    console.log('pinAuth', memberId)
    //window.M.pop.alert(memberId);
    if (memberId !== '') {
      if (window.M.navigator.device('ios')) {
        // ios일 경우
        var params = {}
        params.length = '6'
        params.activity = 'SamplePassCodeViewController'
        window.M.plugin('3rd_iOS_pin_basic').auth({
          param: params,
          callback: function (status, result) {
            console.log('status : ' + status)
            console.log('result : ' + JSON.stringify(result))
            //window.M.pop.alert('result : ' + JSON.stringify(result));
            if (result.result === 'SUCCESS') {
              simplLogin(memberId)
            } else {
              //window.M.pop.instance(result.message);
              errorPin(result.message)
            }
          },
        })
      } else if (window.M.navigator.device('android')) {
        // android일 경우
        window.M.execute('exWNPinLockActivity', {
          length: 6,
          type: 'AUTH',
          callback: window.M.response
          .on(function (status, result) {
              var resultMessage = result.message
              console.log(status)
              console.log(result)
              //window.M.pop.alert('result : ' + JSON.stringify(result) + ", " + 'result : ' + resultMessage);
              //window.M.pop.alert(resultMessage);
              if (result.result === 'SUCCESS') {
                simplLogin(memberId)
                //window.M.pop.instance("성공");
              } else {
                //window.M.pop.instance(result.message);
                errorPin(result.message)
                //window.M.pop.alert('result : ' + JSON.stringify(result) + ", " + 'result : ' + resultMessage);
              }
            })
            .toString(),
          })
        }
    } else {
      //window.M.pop.alert("아이디 로그인을 최소 1회 하셔야 합니다.");
      firstIdLogin() //props.success({ message: '아이디 로그인을 최소 1회 하셔야 합니다.' })
    }
  }

  //패턴로그인
  function patternLogin() {    
    let memberId = window.M.data.storage('memberId')
    console.log('patternLogin', memberId)
    if (memberId !== '') {
      if (window.M.navigator.device('ios')) {
        // ios일 경우
        window.M.plugin('3rd_iOS_pattern_basic').lock({
          type: 'lock',
          callback: function (status, result) {
            // 5회 오류로 재설정 필요
            if (result.message == 'REMOVE') {
              window.M.pop.alert({
                title: '인증 오류',
                message: '5회 오류로 패턴을 재설정 하셔야 합니다.',
                buttons: ['취소', '확인'],
                callback: function (idx) {
                  window.M.plugin('3rd_iOS_pattern_basic').lock({
                    type: 'reset',
                    callback: function (status, result) {
                      if (result.message == 'SUCCESS') {
                        // 패턴 재설정 및 인증 성공
                        console.log('result message : ' + result.message)
                      }
                    },
                  })
                },
              })
            } else if (result.result == 'SUCCESS') {
              // 패턴인증 성공
              console.log('result message : ' + result.message)
              let memberId = window.M.data.storage('memberId')
              simplLogin(memberId)
            } else if (result.result == 'FAIL') {
              // 패턴인증 취소
              console.log('resutl message : ' + result.message)
            }
          },
        })
      } else if (window.M.navigator.device('android')) {
        //android일 경우
        window.M.execute('exWNPatternLockActivity', {
          type: 'lock',
          callback: window.M.response
            .on(function (status, result) {
              console.log(status)
              console.log(result)
              if (result.message == 'REMOVE') {
                // 5회 오류로 패턴 재설정 필요
                window.M.pop.alert({
                  title: '인증 오류',
                  message: '5회 오류로 패턴을 재설정 하셔야 합니다.',
                  buttons: ['확인'],
                  callback: function (idx) {
                    // 원하는 처리
                    window.M.execute('exWNPatternLockActivity', {
                      type: 'reset',
                      callback: window.M.response
                        .on(function (status, result) {
                          console.log(status)
                          console.log(result)
                        })
                        .toString(),
                    })
                  },
                })
              } else if (result.message == 'SUCCESS') {
                console.log('result message : ' + result.message)

                let memberId = window.M.data.storage('memberId')
                simplLogin(memberId)
                //   window.M.pop.instance("성공");
                // 인증 성공
              } else if (result.result == 'FAIL') {
              }
            })
            .toString(),
        })
      }
    } else {
      firstIdLogin()
    }
  }

  //생체인증체크
  function bioCheck() {    
    let memberId = window.M.data.storage('memberId')
    console.log('bioCheck', memberId)
    if (memberId !== '') {
      if (window.M.navigator.device('ios')) {
        // ios일 경우
        window.M.plugin('3rd_iOS_fingerprint_basic').check({
          callback: function (status, result) {
            console.log('status : ' + status)
            console.log('result : ' + JSON.stringify(result))
            // window.M.pop.alert('result : ' + JSON.stringify(result));
            if (result.result == 'SUCCESS') {
              //생체인증 가능...
              //window.M.pop.instance("생체인증 가능");
              bioLogin()
            } else {
              //생체인증 불가능...
              //window.M.pop.instance("등록된 생체인증이 없거나 지원하지 않은 기기입니다.");
              //props.success({ message: '등록된 생체인증이 없거나 지원하지 않은 기기입니다.' })
              errorBio()
              //bioInfoAdd();
            }
          },
        })
      } else if (window.M.navigator.device('android')) {
        // android일 경우
        window.M.plugin('3rd_fingerprint_basic').check({
          callback: function (status, result) {
            console.log(status + JSON.stringify(result))
            //window.M.pop.alert('result : ' + JSON.stringify(result));
            if (result.result == 'SUCCESS') {
              //생체인증 가능...
              //window.M.pop.instance("생체인증 가능");
              bioLogin()
            } else {
              //생체인증 불가능...
              //window.M.pop.instance("등록된 생체인증이 없거나 지원하지 않은 기기입니다.");
              // props.success({ message: '등록된 생체인증이 없거나 지원하지 않은 기기입니다.' })
              errorBio()
            }
          },
        })
      }
    } else {
      //window.M.pop.alert("아이디 로그인을 최소 1회 하셔야 합니다.");
      firstIdLogin()
    }
  }

  function bioInfoAdd() {    
    if (window.M.navigator.device('ios')) {
      // ios일 경우
      var result = window.M.plugin('3rd_iOS_fingerprint_basic').moveSetting()
      console.log('result : ' + JSON.stringify(result))
      // window.M.pop.alert('result : ' + JSON.stringify(result));
    } else if (window.M.navigator.device('android')) {
      // android일 경우
      var result = window.M.plugin('3rd_fingerprint_basic').moveSetting()
      console.log('result : ' + JSON.stringify(result))
      //window.M.pop.alert('result : ' + JSON.stringify(result));
    }
  }

  function bioLogin() {    
    if (window.M.navigator.device('ios')) {
      // ios일 경우
      window.M.plugin('3rd_iOS_fingerprint_basic').auth({
        callback: function (status, result) {
          console.log('status : ' + status)
          console.log('result : ' + JSON.stringify(result))
          //   window.M.pop.alert('result : ' + JSON.stringify(result));
          if (result.result == 'SUCCESS') {
            //window.M.pop.instance(result.result)
            //로그인
            let memberId = window.M.data.storage('memberId')
            simplLogin(memberId)
            //window.M.pop.instance("성공");
          } else {
            setState({
              ...state,
              bioFail: '등록된 생체 정보와 일치하지 않습니다. 다시 시도하세요.',
            })
          }
        },
      })
    } else if (window.M.navigator.device('android')) {
      // android일 경우
      window.M.plugin('3rd_fingerprint_basic').auth({
        callback: function (status, result) {
          console.log('status : ' + status)
          console.log('result : ' + JSON.stringify(result))
          //            window.M.pop.alert('result : ' + JSON.stringify(result));
          if (result.result == 'SUCCESS') {
            //로그인
            let memberId = window.M.data.storage('memberId')
            simplLogin(memberId)
            //window.M.pop.instance("성공");
          } else {
            setState({
              ...state,
              bioFail: '등록된 생체 정보와 일치하지 않습니다. 다시 시도하세요.',
            })
          }
        },
      })
    }
  }

  function KakaoMobileLogin() {    
    window.M.execute(
      'exWNKakaoAuthIsLogin',
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(result)
          // 'OK':로그인 된 상태, 'NEED_LOGIN':로그인 안 된 상태
          //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
          if (status === 'OK') {
            window.M.execute(
              'exWNKakaoAuthLogout',
              window.M.response
                .on(function (status, result) {
                  console.log(status)
                  console.log(result)
                  //   window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
                  if (status === 'SUCCESS') {
                    window.M.execute(
                      'exWNKakaoAuthLogin',
                      window.M.response
                        .on(function (status, result) {
                          console.log(status)
                          console.log(result)
                          //    window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
                          //window.M.pop.alert(status +','+ result.id);
                          if (status === 'SUCCESS') {
                            //props.mobileKakaoLogin(result.id)
                            props.mobileKakaoLogin(result.data.id)
                          }
                        })
                        .toString(),
                    )
                  }
                })
                .toString(),
            )
          } else if (status === 'NEED_LOGIN') {
            window.M.execute(
              'exWNKakaoAuthLogin',
              window.M.response
                .on(function (status, result) {
                  console.log(status)
                  console.log(result)
                  //   window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
                  //window.M.pop.alert(status +','+ result.id);
                  if (status === 'SUCCESS') {
                    //props.mobileKakaoLogin(result.id)
                    props.mobileKakaoLogin(result.data.id)
                  }
                })
                .toString(),
            )
          }
        })
        .toString(),
    )
    window.M.execute(
      'exWNKakaoAuthLogin',
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(result)
          //   window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
          if (status === 'SUCCESS') {
            //props.mobileKakaoLogin(result.id)
            props.mobileKakaoLogin(result.data.id)
          }
        })
        .toString(),
    )
  }

  function NaverMobileLogin() {    
    var result = window.M.execute('exWNNaverAuthIsLogin')
    //window.M.pop.alert(', result : ' + JSON.stringify(result));
    if (result === 'OK') {
      window.M.execute('exWNNaverAuthLogout')
      window.M.execute(
        'exWNNaverAuthLogin',
        window.M.response
          .on(function (status, result) {
            console.log(status)
            console.log(result.data.id)

            // window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));

            if (status === 'SUCCESS') {
              props.mobileNaverLogin(result.data.id)
            }
          })
          .toString(),
      )
    } else if (result === 'NEED_LOGIN' || result === 'NEED_REFRESH_TOKEN') {
      window.M.execute(
        'exWNNaverAuthLogin',
        window.M.response
          .on(function (status, result) {
            console.log(status)
            console.log(result.data.id)

            //   window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));

            if (status === 'SUCCESS') {
              props.mobileNaverLogin(result.data.id)
            } else {
              window.M.execute('exWNNaverAuthLogout')
            }
          })
          .toString(),
      )
    }

    /* window.M.execute(
      'exWNNaverAuthLogin',
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(result)
          window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result))
          if (status === 'SUCCESS') {
            //  props.mobileNaverLogin(result.id)
          }
        })
        .toString(),
    ) */
  }

  function AppleLogin() {    
    if (window.M.navigator.device('ios') == true) {
      let memberId = window.M.data.storage('memberId')
      if (memberId !== '') {
        window.M.execute(
          'exWNAppleAuthLogin',
          window.M.response
            .on(function (status, result) {
              //console.log(status);
              //console.log(result);
              //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
              if (status === 'SUCCESS') {
                simplLogin(memberId)
              } else {
                errorApple()
              }
            })
            .toString(),
        )
      } else {
        firstIdLogin()
      }
    }
  }

  useEffect(() => {    
    props.callDgtOnePass()
  }, [])

  useEffect(() => {    
    setState({ ...state, data: props.auth })
  }, [props.auth])

  // useEffect(() => {
  //   setState({ ...state, uuid: props.uuid })
  // }, [props.uuid])

  useEffect(() => {    
    let userInfo = localStorage.getItem('user')

    if (commons.isMobile() && userInfo != null) {
      props.logOut()
    }

    let lastLogin = localStorage.getItem('lastLogin')
    let userId = localStorage.getItem('saveId')

    if (lastLogin) {
      let today = moment().hour(0).minute(0).second(0).millisecond(0)
      let day = moment.duration(today.diff(moment(lastLogin))).asDays()

      if (day > 7) {
        localStorage.removeItem('saveId')
        localStorage.removeItem('lastLogin')
        userId = null
      }
    }

    userId && setState({ ...state, userName: userId, isSaveId: true })
  }, [])

  const handleChange = (e) => {    
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const { userName, password, isSaveId } = state

    if (!userName) return props.error({ message: '아이디를 입력하세요.' })
    if (!password) return props.error({ message: '비밀번호를 입력하세요.' })

    setState({
      ...state,
      submitted: true,
    })
    props.logIn(userName, password, isSaveId)
  }

  const openUth = () => {
    if (commons.isMobile()) {
      history.push('/openLink')
    }
  }

  const checkHandler = (e) => {    
    const { id, checked } = e.target

    setState({
      ...state,
      [id]: checked,
    })
  }

  //tab
  let [step, setStep] = useState(1)

  const onSelected = (value) => {    
    //console.log(value)
    if (value == '4') {
      setStep(value)
      qrMakeImg()
      setActive(1)
      setMinutes(3)
      setSeconds(0)
      setReloadButton(false)
      //qrLogin()
    } else if (value == '5') {
      console.log('간편번호')
      //기본 적용
      setStep(value)
      setMinutes(0)
      setSeconds(0)
      setReloadButton(false)
    } else if (value == '6') {
      console.log('패턴')

      //기본 적용
      setStep(value)
      setMinutes(0)
      setSeconds(0)
      setReloadButton(false)
    } else if (value == '7') {
      console.log('생체인식')

      //기본 적용
      setStep(value)
      setMinutes(0)
      setSeconds(0)
      setReloadButton(false)
    } else {
      setStep(value)
      setMinutes(0)
      setSeconds(0)
      setReloadButton(false)
    }
  }
  const qrimg = state.data?.qrImg
  const ranNum = state.data?.ranNum

  //localStorage.setItem("ranNum",ranNum);
  //console.log("---ranNum----:>",ranNum);
  const [minutes, setMinutes] = useState()
  const [seconds, setSeconds] = useState()
  const [reloadButton, setReloadButton] = useState(false)

  useEffect(() => {    
    const countdown = setInterval(() => {
      if (parseInt(seconds) > 0) {
        setSeconds(parseInt(seconds) - 1)
      }
      if (parseInt(seconds) === 0) {
        if (parseInt(minutes) === 0) {
          clearInterval(countdown)
          //  console.log('완료')
          setActive(2)
          setReloadButton(true)
        } else {
          setMinutes(parseInt(minutes) - 1)
          setSeconds(59)
        }
      }
    }, 1000)
    //console.log("진행중")	//로그인 체크 로직
    if (ranNum !== undefined && ranNum !== null) {
      props.qrLoginCheck(ranNum)
    }

    return () => clearInterval(countdown)
  }, [minutes, seconds])

  const resetButton = () => {    
    setActive(1)
    qrMakeImg()
    setMinutes(3)
    setSeconds(0)
    setReloadButton(false)
  }

  /**
   * qr 생성
   * @param info
   */
  const qrMakeImg = () => {
    props.qrMakeImg()
  }

  /**
   * qr Login check
   * @param info
   */
  /*   const startQrLoginCheck = (param) => {
    try {
      return axios.get(uriConstants.API_URI + uriConstants.QR_LOGIN,
        '/ranNum=' + param)
    } catch (error) {
      console.error(error)
    }
  }

  const qrLoginCheck = (param) => {
    const breeds = startQrLoginCheck(param)
      .then((response) => {
        if (response.data.message) {
          console.log(`${Object.entries(breeds.data.message).length}`)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  } */

  /**
   * 인증서 콜백
   * @param info
   */
  const crtfctInfo = (info) => {
    console.log('info : ', info)
    props.passCrtfctfLogin(info, '1',"N")
  }

  var changeImage = {
    backgroundImage: `url(data:image/PNG;base64,${qrimg})`,
  }
  var changeImage2 = {
    backgroundImage: `url(data:image/png;base64,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)`,
  }

  useEffect(() => {    
    $('#loginSelect').on('click', function () {
      $(this).toggleClass('on off')
    })
    $('#loginList li').on('click', function () {
      $('#loginSelect').removeClass('on')
      $('#loginSelect').text($(this).text())
    })
  }, [])

  /**
   * 네이티브 화면 메시지 처리
   */
  const errorBio = () => {    
    props.success({
      title: '확인',
      message: '등록된 생체인증이 없거나 지원하지 않은 기기입니다.',
      params: {
        type: 'SUCCESS',
        callback: () => {
          bioInfoAdd()
        },
      },
    })
  }

  const errorPin = (message) => {    
    props.success({
      title: '확인',
      message: message,
      params: {
        type: 'SUCCESS',
        callback: () => {
          return
        },
      },
    })
  }

  const firstIdLogin = () => {    
    props.success({
      title: '확인',
      message: '아이디 로그인을 최소 1회 하셔야 합니다.',
      params: {
        type: 'SUCCESS',
        callback: () => {
          return
        },
      },
    })
  }

  const errorApple = () => {    
    props.success({
      title: '확인',
      message: '애플 인증에 실패하였습니다..',
      params: {
        type: 'SUCCESS',
        callback: () => {
          bioInfoAdd()
        },
      },
    })
  }

  //인증서 목록 가져오기
  useEffect(() => {
    if(common.getDeviceType() ==='MobileApp'){
      window.M.execute(
        'exWNGetCertList',
        window.M.response
          .on(function (status, result) {
            console.log(status)
            console.log(result)
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result.data.certList));
            if (status === 'SUCCESS') {
              setState({ ...state, crtfctDetailList: result.data.certList })
            }
          })
          .toString(),
      )
    }
    if(common.getDeviceType() ==='MobileApp'){
      window.M.execute(
        'exWNGetCertList',
        '',
        window.M.response
          .on(function (status, result) {
            console.log(status)
            console.log(result)
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result.data.certList));
            // if (status === 'SUCCESS') {
            //   setState({ ...state, crtfctDetailList: result.data.certList })
            // }
          })
          .toString(),
      )
    }
  }, [])
  // 모바일 공동인증서 로그인
  function setMobileCrtfct() {
    let paramUrlCode = props.location?.search?.split("=")[0]
    let paramEcdwAdres = props.location?.search?.split("=")[1]
    console.log(paramUrlCode)
    console.log(paramEcdwAdres)
    const { crtfctPassword } = state
    if (!crtfctPassword) return props.error({ message: '비밀번호를 입력하세요.' })
    var subjectDn = state.selectedCrtfctInfo.subjectDn //document.getElementById("subjectDn").value
    console.log('subjectDn : ', subjectDn)
    var data = new Date().toISOString().substr(0, 10).replace('T', ' ')
    if(paramUrlCode !== ""){
      data = paramEcdwAdres
      paramUrlCode = paramUrlCode.replace(removeQ,'')
    }
    console.log('date', data)
    var loginData = ''
    // let paramsTest2 = {}
    // Object.assign(paramsTest2,{url:'Login.js 820'})
    // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest2,{headers:{},})
    async function temp(myData){
    let paramsTest2 = {}
      window.M.execute(
        'exWNMakeSignData',
        subjectDn,
        myData,
        crtfctPassword,
        window.M.response
          .on(function (status, result) {
            loginData = result.data.signData
            props.setSignData(loginData)
            // Object.assign(paramsTest2,{url:'Login.js 843'})
            // Object.assign(paramsTest2,{loginData:loginData})
            // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest2,{headers:{},})
            let user = JSON.parse(localStorage.getItem('user'))
            user.payload.signData = loginData
            localStorage.setItem('user',JSON.stringify(user))
            // history.replace('/')
            document.location.href = '/'
          })                                                                  
          .toString(),
      )
      return ''
    }
    if (window.M.navigator.device('ios')) {
      window.M.execute(
        'exWNMakeSignData',
        subjectDn,
        data,
        crtfctPassword,
        window.M.response
          .on(function (status, result) {
            loginData = result.data.signData
            console.log('status', status)
            console.log('result', result)
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
            if (status === 'SUCCESS') {
              if(paramUrlCode !== ""){
                props.setSignData(loginData)
                let tempUserStr = localStorage.getItem('user')
                if(tempUserStr){
                  let tempUser = JSON.parse(tempUserStr)
                  tempUser.payload.signData = loginData
                  localStorage.setItem('user',JSON.stringify(tempUser))
                }
                const params = {
                  deviceId: deviceId,
                  ecdwAdres: paramEcdwAdres,
                  signedData: loginData,
                  urlCode: paramUrlCode,
                }
                // 지갑 화면 URL 요청
                props.getScreenURL(params)
              }else{
                props.passCrtfctfLoginIos(loginData, '1', "Y",temp)
              }
            } else {
              crtfctFail()
            }
          })                                                                  
          .toString(),
      )
    } else if (window.M.navigator.device('android')) {
      window.M.execute(
        'exWNMakeSignData',
        subjectDn,
        data,
        crtfctPassword,
        window.M.response
          .on(function (status, result) {
            loginData = result.data.signData
            console.log('status', status)
            console.log('result', result)
            //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
            // Object.assign(paramsTest2,{url:'Login.js 866'})
            // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest2,{headers:{},})
            if (status === 'SUCCESS') {
              // let paramsTest = {'status':status,'result':result.data?.signData.substr(0,10)}
              // Object.assign(paramsTest,{url:'Login.js 864'})
              // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest,{headers:{},})
              if(paramUrlCode !== ""){
                props.setSignData(loginData)
                let tempUserStr = localStorage.getItem('user')
                if(tempUserStr){
                  let tempUser = JSON.parse(tempUserStr)
                  tempUser.payload.signData = loginData
                  localStorage.setItem('user',JSON.stringify(tempUser))
                }
                const params = {
                  deviceId: deviceId,
                  ecdwAdres: paramEcdwAdres,
                  signedData: loginData,
                  urlCode: paramUrlCode,
                }
                // 지갑 화면 URL 요청
                props.getScreenURL(params)
              }else{
                props.passCrtfctfLogin(loginData, '1', "Y",temp)
              }
            } else {
              crtfctFail()
            }
          })
          .toString(),
      )
    }
  }

  const handleClick = (info, index) => {
    
    setState({
      ...state,
      selected: true,
      selectedCrtfctInfo: info,
      crtfctDetailList: state.crtfctDetailList.map((detail, idx) =>
        idx === index ? { ...detail, editableColor: '#B0ECFF' } : { ...detail, editableColor: '' },
      ),
    })
  }

  /**
   * 네이티브 화면 메시지 처리
   */
  const crtfctFail = () => {
    
    props.success({
      title: '확인',
      message: ' 인증서 검증에 실패하였습니다',
      params: {
        type: 'SUCCESS',
        callback: () => {
          return
        },
      },
    })
  }

  return (
    <React.Fragment>
      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          <div className="content-header type2">
            <a
              onClick={(e) => {
                e.preventDefault()
                window.history.back()
              }}
              className="page-prev cursor"
            >
              뒤로이동
            </a>
            {/* <!-- mobile --> */}
            <h2>로그인</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <em>로그인</em>
            </div>
          </div>
          <div className="login-wrap">
            <ul className="nav-tab tabs">
              <li
                className={step === 1 ? 'on' : ''}
                onClick={() => {
                  onSelected(1)
                }}
              >
                <a className="cursor">아이디</a>
              </li>
              <li
                className={step === 2 ? 'on' : ''}
                onClick={() => {
                  onSelected(2)
                }}
              >
                <a className="cursor">공동인증서</a>
              </li>
              {/* <li
                className={step === 3 ? 'on' : ''}
                onClick={() => {
                  onSelected(3)
                }}
              >
                <a className="cursor">디지털원패스</a>
              </li> */}
              <li
                className={step === 4 ? 'on' : ''}
                onClick={() => {
                  onSelected(4)
                }}
              >
                <a className="cursor">QR인증</a>
              </li>
            </ul>
            {/* <!-- mobile --> */}
            <div className="nav-wrap">
              <a id="loginSelect" className="current-menu on cursor">
                아이디
              </a>
              <ul className="nav-menu" id="loginList">
                <li className="on">
                  <a
                    className="cursor"
                    onClick={() => {
                      onSelected(1)
                    }}
                  >
                    아이디
                  </a>
                </li>
                <li>
                  <a
                    className="cursor"
                    onClick={() => {
                      onSelected(2)
                    }}
                  >
                    공동인증서
                  </a>
                </li>
                {/* <li>
                  <a
                    className="cursor"
                    onClick={() => {
                      onSelected(3)
                    }}
                  >
                    디지털원패스
                  </a>
                </li> */}
                <li>
                  <a
                    className="cursor"
                    onClick={() => {
                      onSelected(5)
                    }}
                  >
                    간편번호
                  </a>
                </li>
                <li>
                  <a
                    className="cursor"
                    onClick={() => {
                      onSelected(6)
                    }}
                  >
                    패턴
                  </a>
                </li>
                <li>
                  <a
                    className="cursor"
                    onClick={() => {
                      onSelected(7)
                    }}
                  >
                    생체인식
                  </a>
                </li>
              </ul>
            </div>
            {step === 5 && (
              <>
                <div id="login-tab5" className="simple-login">
                  <dl className="desc">
                    <dt>간편번호 인증</dt>
                    <dd></dd>
                  </dl>
                  <button type="button" onClick={pinAuth} className="btn-confirm">
                    간편번호 인증
                  </button>
                </div>
                <div className="guide-box gray">
                  <dl className="dlist1">
                    <dt>이용안내</dt>
                    <dd>간편번호 인증은 전자문서지갑 회원 중 간편인증 등록한 경우 이용이 가능합니다.</dd>
                    <dd>‘마이페이지 → 로그인설정 → 간편번호 인증’에서 계정 연동이 가능합니다.</dd>
                  </dl>
                </div>
              </>
            )}
            {step === 6 && (
              <>
                <div id="login-tab6" className="pattern-login">
                  <dl className="desc">
                    <dt>패턴 인증</dt>
                    <dd></dd>
                  </dl>
                  <button type="button" onClick={patternLogin} className="btn-confirm">
                    패턴 인증
                  </button>
                </div>
                <div className="guide-box gray">
                  <dl className="dlist1">
                    <dt>이용안내</dt>
                    <dd>패턴 인증은 전자문서지갑 회원 중 간편인증 등록한 경우 이용이 가능합니다.</dd>
                    <dd>‘마이페이지 → 로그인설정 → 패턴 인증’에서 설정이 가능합니다.</dd>
                  </dl>
                </div>
              </>
            )}
            {step === 7 && (
              <>
                <div className="body-login">
                  <dl className="desc">
                    <dt className="text-red">{state.bioFail}</dt>
                    <dd></dd>
                  </dl>
                  <button type="button" onClick={bioCheck} className="btn-confirm">
                    생체 인증
                  </button>
                  {/* <button type="button" onCilck={bioCheck} className="btn-confirm mt8">
                    페이스 인증
                  </button> */}
                </div>
                <div className="guide-box gray">
                  <dl className="dlist1">
                    <dt>이용안내</dt>
                    <dd>생체 인증은 전자문서지갑 회원 중 생체인증 등록한 경우 이용이 가능합니다.</dd>
                    {/* <dd>‘마이페이지 → 로그인설정 → 지문인증’에서 설정이 가능합니다.</dd> */}
                  </dl>
                </div>
              </>
            )}
            {/* <!-- //mobile --> */}
            <div className="tab-container">
              {step === 1 && (
                <div id="login-tab1" className="tab-cont">
                  <div className="login-cont">
                    <div className="login-input">
                      <form name="form" onSubmit={handleSubmit}>
                        <fieldset style={{ position: 'relative' }}>
                          <Input
                            type={'text'}
                            id="userName"
                            name="userName"
                            value={state.userName}
                            className="form-control input-text"
                            placeholder="아이디"
                            message={'아이디를 입력하세요'}
                            onChange={(e) => handleChange(e)}
                            required={true}
                            numberOnly={false}
                            inputTitle={'아이디 입력'}
                            flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                            submitted={state.submitted}
                          />
                          <Input
                            type={pType}
                            id="password"
                            name="password"
                            value={state.password}
                            className="form-control input-text"
                            placeholder="비밀번호"
                            inputTitle={'비밀번호 입력'}
                            message={'비밀번호를 입력하세요'}
                            onChange={(e) => handleChange(e)}
                            required={true}
                            numberOnly={false}
                            flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                            submitted={state.submitted}
                          />
                          <img
                            src= {pType === 'password' ? ico_eye : ico_eye_slash }
                            alt=""
                            className="pc-only"
                            onClick={(e) => {
                              e.preventDefault()
                              setPType(pType === 'password' ? 'text' : 'password')
                            }}
                            style={{
                              position: 'absolute',
                              right: '-20px',
                              bottom: '65px',
                              maxWidth: '30px',
                            }}
                          />
                          <div className="idsave">
                            <input id="isSaveId" type="checkbox" checked={state.isSaveId} onChange={checkHandler} />
                            <em />
                            <label htmlFor="isSaveId">아이디 저장</label>
                            {/* {isMobile && (
                              <a href="/LoginPass" className="link-arr float-r">
                                간편비밀번호 로그인 <BsChevronRight />
                              </a>
                            )} */}
                          </div>
                        </fieldset>
                        <button className="btn-login">로그인</button>
                      </form>
                      <div className="idpw_list">
                        <a href="https://wallet.utradehub.or.kr/regis/join">회원가입</a>
                        <a href="/find/id?gbn=1">아이디 찾기</a>
                        <a href="/find/pass?gbn=1">비밀번호 찾기</a>
                      </div>
                      {/*<p className="sns-tit">SNS 계정 로그인</p>*/}
                      {/*<div className="sns-btn">*/}
                      {/*  /!* <a href={NAVER_AUTH_URL}>*/}
                      {/*    <span>*/}
                      {/*      <button type="button" className="btn-naver">*/}
                      {/*        네이버 계정으로 로그인*/}
                      {/*      </button>*/}
                      {/*    </span>*/}
                      {/*  </a>*/}
                      {/*  <a href={KAKAO_AUTH_URL}>*/}
                      {/*    <span>*/}
                      {/*      <button type="button" className="btn-kakao">*/}
                      {/*        카카오 계정으로 로그인*/}
                      {/*      </button>*/}
                      {/*    </span>*/}
                      {/*  </a> *!/*/}
                      {/*  {common.getDeviceType() === 'MobileApp' ? (*/}
                      {/*    <>*/}
                      {/*      <span>*/}
                      {/*        <button type="button" onClick={NaverMobileLogin} className="btn-naver">*/}
                      {/*          네이버 계정으로 로그인 모바일*/}
                      {/*        </button>*/}
                      {/*      </span>*/}
                      {/*      <span>*/}
                      {/*        <button type="button" onClick={KakaoMobileLogin} className="btn-kakao">*/}
                      {/*          카카오 계정으로 로그인 모바일*/}
                      {/*        </button>*/}
                      {/*      </span>*/}
                      {/*    </>*/}
                      {/*  ) : (*/}
                      {/*    <>*/}
                      {/*      /!* <a href={NAVER_AUTH_URL}> *!/*/}
                      {/*      <span>*/}
                      {/*        <button*/}
                      {/*          type="button"*/}
                      {/*          className="btn-naver"*/}
                      {/*          onClick={() => {*/}
                      {/*            window.location.href = NAVER_AUTH_URL*/}
                      {/*          }}*/}
                      {/*        >*/}
                      {/*          네이버 계정으로 로그인*/}
                      {/*        </button>*/}
                      {/*      </span>*/}
                      {/*      /!* </a> *!/*/}
                      {/*      /!* <a href={KAKAO_AUTH_URL}> *!/*/}
                      {/*      <span>*/}
                      {/*        <button*/}
                      {/*          type="button"*/}
                      {/*          className="btn-kakao"*/}
                      {/*          onClick={() => {*/}
                      {/*            window.location.href = KAKAO_AUTH_URL*/}
                      {/*          }}*/}
                      {/*        >*/}
                      {/*          카카오 계정으로 로그인*/}
                      {/*        </button>*/}
                      {/*      </span>*/}
                      {/*      /!* </a> *!/*/}
                      {/*    </>*/}
                      {/*  )}*/}
                      {/*  {window.M.navigator.device('ios') && (*/}
                      {/*    <button type="button" onClick={AppleLogin} className="btn-apple">*/}
                      {/*      Apple로 로그인*/}
                      {/*    </button>*/}
                      {/*  )}*/}

                      {/*  /!* <!-- mobile --> *!/*/}
                      {/*</div>*/}
                    </div>
                  </div>
                  <div className="guide-box gray">
                    <dl className="dlist1">
                      <dt>이용안내</dt>
                      <dd>회원님의 개인정보보호를 위해 일정시간(약 30분) 동안 이용하지 않으면 자동 로그아웃 됩니다.</dd>
                      <dd>회원님의 암호는 주기적으로 변경하고 타인에게 노출되지 않도록 주의하시기 바랍니다.</dd>
                      <dt>소셜 로그인 이용안내</dt>
                      <dd>소셜 로그인은 전자문서지갑 회원 중 소셜 계정 연동 후 이용이 가능합니다.</dd>
                      <dd>‘마이페이지 → 로그인설정 → SNS로그인 설정’에서 계정 연동이 가능합니다.</dd>
                    </dl>
                  </div>
                </div>
              )}
              {step === 2 &&
                (common.getDeviceType() === 'MobileApp' ? (
                  <div id="login-tab2" className="tab-cont">
                    {state.crtfctDetailList.length > 0 ? (
                      <div className="certify-wrap" style={{ marginTop: '40px' }}>
                        <ul className="certify-list">
                          {state.crtfctDetailList.map((info, index) => (
                            <li onClick={() => handleClick(info, index)} style={{ backgroundColor: info.editableColor }}>
                              <a href="#">
                                <div className="box">
                                  <div className="img"></div>
                                  <div className="info">
                                    <dl key={index}>
                                      <dt>
                                        {info.subjectDn.split('=')[1].split('(')[0]}
                                        <input type="hidden" id="subjectDn" name="subjectDn" value={info.subjectDn} />
                                      </dt>
                                      <dd>{info.issuerDn.split('=')[3].split(',')[0]}</dd>
                                      <dd>만료일 : {moment(info.notAfter).format('YYYY.MM.DD')}</dd>
                                    </dl>
                                  </div>
                                </div>
                              </a>
                            </li>
                          ))}
                        </ul>
                        {
                          <>
                            <div className="certify-password">
                              <p className="tit">인증서 비밀번호를 입력하세요.</p>
                              <input
                                type="password"
                                className="form-keyword"
                                title={'비밀번호 입력'}
                                id="crtfctPassword"
                                name="crtfctPassword"
                                value={state.crtfctPassword}
                                onChange={(e) => handleChange(e)}
                              />
                            </div>
                            <div className="common-login">
                              <a className="btn-primary sm cursor" onClick={setMobileCrtfct}>
                                로그인
                              </a>
                            </div>
                          </>
                        }
                      </div>
                    ) : (
                      <div className="common-login">
                        <dl className="desc">
                          <dt>공동인증서 로그인</dt>
                          <dd>
                            전자문서지갑 회원 대상으로,
                            <br /> 홈페이지에 <strong>최초 1회 인증서 등록 후</strong> 이용 가능합니다.
                          </dd>
                        </dl>
                      </div>
                    )}
                    <div className="guide-box gray">
                      <dl className="dlist1">
                        <dt>이용안내</dt>
                        <dd>은행인증서(무료) 또는 범용인증서(유료) 모두 이용 가능합니다.</dd>
                        <dd>비밀번호 5회 이상 입력 오류 시 재시도 해주시기 바랍니다.</dd>
                        <dt>공동인증서 로그인 안내</dt>
                        <dd>인증서 로그인은 전자문서지갑 회원 중 인증서를 등록한 경우 이용 가능합니다.</dd>
                        <dd>'마이페이지 → 인증서관리 → 인증서 등록'에서 등록이 가능합니다.</dd>
                      </dl>
                    </div>
                  </div>
                ) : (
                  <div id="login-tab2" className="tab-cont">
                    <div className="common-login">
                      <dl className="desc">
                        <dt>공동인증서 로그인</dt>
                        <dd>
                          전자문서지갑 회원 대상으로,
                          <br /> 홈페이지에 <strong>최초 1회 인증서 등록 후</strong> 이용 가능합니다.
                        </dd>
                      </dl>
                      {
                        <a
                          className="btn-primary sm cursor"
                          onMouseDown={() => {
                            setIsKTnetOpen(true)
                          }}
                        >
                          로그인
                        </a>
                      }
                    </div>
                    <div className="guide-box gray">
                      <dl className="dlist1">
                        <dt>이용안내</dt>
                        <dd>은행인증서(무료) 또는 범용인증서(유료) 모두 이용 가능합니다.</dd>
                        <dd>비밀번호 5회 이상 입력 오류 시 재시도 해주시기 바랍니다.</dd>
                        <dt>공동인증서 로그인 안내</dt>
                        <dd>인증서 로그인은 전자문서지갑 회원 중 인증서를 등록한 경우 이용 가능합니다.</dd>
                        <dd>'마이페이지 → 인증서관리 → 인증서 등록'에서 등록이 가능합니다.</dd>
                      </dl>
                    </div>
                  </div>
                ))}
              <KTnetModal3
                isKTnetOpen={isKTnetOpen}
                onChange={() => setIsKTnetOpen(false)}
                sendCrtfctInfo={crtfctInfo}
                setSignedData={setSignedData}
                error={props.error}
                param={props.location?.search}
              />
              {step === 3 && (
                <div id="login-tab3" className="tab-cont">
                  <div className="digital-login">
                    <dl className="desc">
                      <dt>디지털원패스 로그인</dt>
                      <dd>
                        <strong>하나의 아이디로 본인이 선택한 인증수단을 사용</strong>
                        하여
                        <br /> 여러 전자정부 서비스를 이용할 수 있는 인증 서비스입니다
                      </dd>
                    </dl>
                    <form name="oform" action={state.data?.action} method="POST">
                      <input type="hidden" name={state.data?.inputName} value={state.data?.inputValue} />
                      <input type="hidden" name="returnUrl" value={uriConstants.API_URI + uriConstants.ADD_ONEPASS_CHECK  + "?stateType=Login"} />
                      {/* <input type="hidden" name="stateType" value="Login" /> */}
                      <button type="submit" className="btn-login onepass">
                        디지털원패스 로그인
                      </button>
                    </form>
                  </div>
                  <div className="guide-box gray">
                    <dl className="dlist1">
                      <dt>이용안내</dt>
                      <dd>디지털원패스 이용문의 : 1533-3713(평일 9~18시 / 공휴일제외)</dd>
                    </dl>
                  </div>
                </div>
              )}
              {step === 4 && (
                <div id="login-tab4" className="tab-cont">
                  <div className="qr-login">
                    <dl className="desc">
                      <dt>QR인증 로그인</dt>
                      {/* <img src={`data:image/PNG;base64,${qrimg}`} ></img> */}
                      {/* <dd ref={qrimage} style={{ backgroundImage: `url(data:image/PNG;base64,${qrimg})` }}> */}
                      <dd id="qrimage" style={active === 1 ? changeImage : changeImage2}>
                        <div className="time">
                          {reloadButton ? (
                            <button onClick={resetButton}>다시시작</button>
                          ) : (
                            <span>
                              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                            </span>
                          )}
                        </div>
                        <br></br>
                        <strong>앱에서 QR코드 스캔을</strong>하여 로그인을 승인하면
                        <br /> 회원님 아이디로 PC에 로그인이 됩니다.
                      </dd>
                    </dl>
                    {/* 디지털 원패스 로그인 숨김 처리 */}
                    {/* <button type="button" className="btn-login onepass">
                      디지털원패스 로그인
                    </button> */}
                  </div>
                  <div className="guide-box gray">
                    <dl className="dlist1">
                      <dt>이용안내</dt>
                      <dd>전자문서지갑 회원에 한해 앱 설치 후 이용 가능합니다.</dd>
                      <dd>앱 실행하여 마이페이지 → 모바일 인증 → 웹 인증 → QR코드 스캔 또는 인증번호 입력으로 본인인증이 가능합니다.</dd>
                    </dl>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* //contents */}
      </div>
      {/* //container */}
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.data,
    uuid: state.auth.uuid,
  }
}

const actionCreators = {
  logIn: authActions.logIn,
  logOut: authActions.logOut,
  getCurrentUser: authActions.getCurrentUser,
  error: alertActions.error,
  success: alertActions.success,
  getScreenURL: govCertapplyActions.getScreenURL,
  passCrtfctfLogin: authActions.passCrtfctfLogin,
  passCrtfctfLoginIos: authActions.passCrtfctfLoginIos,
  passCrtfctfLoginTest: authActions.passCrtfctfLoginTest,
  callDgtOnePass: authActions.callDgtOnePass,
  qrMakeImg: authActions.qrMakeImg,
  qrLoginCheck: authActions.qrLoginCheck,
  simplLogin: authActions.simplLogin,
  checkUuid: authActions.checkUUID,
  mobileKakaoLogin: authActions.mobileKakaoLogin,
  mobileNaverLogin: authActions.mobileNaverLogin,
  setSignData : userinfoActions.setSignData,
}

export default connect(mapStateToProps, actionCreators)(Login)
